import React, { useEffect, useState } from "react";
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { ListadoOrdenes } from "./ListadoOrdenes";
import { ESTADOS_ORDEN_PRODUCCION } from "../../../../../../../../../../utility/constants";

export const TabsOrdenes = ({
    turnoActual,
    navigateToTancadas,
    tab2,
    handleChangeTab2,
}) => {
    if (!turnoActual) {
        return (
            <h5 className="text-center my-5">
                Por favor, inicie su turno como supervisor para ver las órdenes
                de producción disponibles
            </h5>
        );
    }

    return (
        <div>
            <h5 className="my-3 text-center">Órdenes de producción</h5>
            <Tabs
                activeKey={tab2}
                tabBarPosition="top"
                onChange={(tab2) => {
                    handleChangeTab2(tab2);
                }}
                renderTabBar={() => <TabBar />}
                renderTabContent={() => <TabContent />}
            >
                <TabPane tab="Pendientes" key="PENDIENTES">
                    <ListadoOrdenes
                        turnoActual={turnoActual}
                        navigateToTancadas={navigateToTancadas}
                        estado={ESTADOS_ORDEN_PRODUCCION.PENDIENTE}
                    />
                </TabPane>
                <TabPane tab="Iniciadas" key="INICIADAS">
                    <ListadoOrdenes
                        turnoActual={turnoActual}
                        navigateToTancadas={navigateToTancadas}
                        estado={ESTADOS_ORDEN_PRODUCCION.EN_PROCESO}
                    />
                </TabPane>
                <TabPane tab="Finalizadas" key="FINALIZADAS">
                    <ListadoOrdenes
                        turnoActual={turnoActual}
                        estado={ESTADOS_ORDEN_PRODUCCION.COMPLETADO}
                    />
                </TabPane>
            </Tabs>
        </div>
    );
};
